import {Validators} from '@angular/forms';
import {FieldsOptions} from '@sim/form';

import {FilterFieldsOptions} from '@ui/ui.module';
import {Status} from './status';

export const isSourceBibliographic = (data: any): data is SourceBibliographic => typeof data === 'object' && data && !Reflect.has(data, 'error') && Reflect.has(data, 'id') && Reflect.has(data, 'livelloBibliografico');

export interface SourceBibliographic {
  id: string;
  annoEdizione: string;
  autore: string[];
  codiceUnico: string;
  collocazione: string;
  curatore: string | null;
  fondo: string;
  editore: string;
  lingua: string[];
  livelloBibliografico: string;
  luogoEdizione: string;
  nazione: string;
  note: string;
  tag: string[];
  tipo: string;
  titolo: string;
  titoloOperaPrincipale: string;
  status: Status;
  /** Id of the image file */
  immagine: string;
  /** Id of the file */
  file: string;
  createdAt: string;
  updatedAt: string;
  /** Id of the user */
  user: string;
  descrizioneFisica: string;
}

export interface SourceBibliographicFilter {
  annoEdizione?: string;
  autore?: string;
  collocazione?: string;
  fondo?: string;
  tag: string;
  tipo: string;
  titolo: string;
}

export const SourceBibliographicMeta: FieldsOptions<SourceBibliographic> = {
  annoEdizione: {},
  autore: {type: 'array'},
  codiceUnico: {validators: Validators.required},
  collocazione: {},
  createdAt: {},
  curatore: {},
  descrizioneFisica: {value: ''},
  editore: {},
  file: {},
  fondo: {},
  id: {},
  immagine: {},
  lingua: {type: 'array'},
  livelloBibliografico: {},
  luogoEdizione: {},
  nazione: {},
  note: {},
  status: {value: Status.STATUS_DRAFT},
  tag: {type: 'array'},
  tipo: {},
  titolo: {validators: Validators.required},
  titoloOperaPrincipale: {},
  updatedAt: {},
  user: {},
};

export const SourceBibliographicFilterMeta: FilterFieldsOptions<SourceBibliographicFilter> = {
  annoEdizione: {operator: 'equal'},
  autore: {operator: 'contains'},
  collocazione: {operator: 'begins_with'},
  fondo: {operator: 'contains'},
  tag: {operator: 'contains'},
  tipo: {operator: 'begins_with'},
  titolo: {operator: 'contains'},
};
